import { apiSlice } from './apiSlice';
import type { FarmUserItem } from '../models/Farm';

const adaptSaveUser = (item: any): FarmUserItem => {
  const userId = String(item.user?.id ?? item.userId ?? item.user_id ?? '');
  const roleCode = item.membership?.role?.code ?? item.role ?? item.roleCode ?? '';
  return {
    user: {
      id: userId,
      name: item.user?.name ?? item.user?.pseudo ?? userId,
      email: item.user?.email ?? '',
      username: item.user?.username ?? item.user?.telegram_username ?? undefined,
    },
    membership: {
      role: {
        id: roleCode,
        code: roleCode,
      },
      isActive: true,
      addedAt: item.membership?.addedAt ?? item.createdAt ?? item.created_at ?? '',
    },
  };
};

export const saveUsersApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getSaveUsers: build.query<FarmUserItem[], string>({
      query: (saveId) => ({ url: `/saves/${saveId}/users` }),
      transformResponse: (response: any) => {
        const users = response?.users ?? response ?? [];
        return Array.isArray(users) ? users.map(adaptSaveUser) : [];
      },
      providesTags: (result, error, saveId) => [{ type: 'FarmUsers', id: saveId }],
    }),
    detachSaveUser: build.mutation<void, { saveId: string; userId: string }>({
      query: ({ saveId, userId }) => ({
        url: `/saves/${saveId}/users/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { saveId }) => [{ type: 'FarmUsers', id: saveId }],
    }),
    assignSaveUserRole: build.mutation<FarmUserItem, { saveId: string; userId: string; roleCode: string }>({
      query: ({ saveId, userId, roleCode }) => ({
        url: `/saves/${saveId}/users`,
        method: 'POST',
        body: { userId, role: roleCode },
      }),
      invalidatesTags: (result, error, { saveId }) => [{ type: 'FarmUsers', id: saveId }],
    }),
  }),
});

export const {
  useGetSaveUsersQuery,
  useDetachSaveUserMutation,
  useAssignSaveUserRoleMutation,
} = saveUsersApi;